<template>
  <transition name="fade">
    <div v-if="visible" class="toast" :class="type">
      {{ message }}
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      message: "",
      type: "",
    };
  },
  methods: {
    show(message, duration = 1500) {
      this.message = message;
      this.visible = true;
      setTimeout(() => {
        this.visible = false;
      }, duration);
    },
  },
};
</script>

<style scoped>
.toast {
  box-sizing: border-box;
  position: fixed;
  top: 30%;
  left: 50%;
  right: -50%;
  transform: translateX(-50%);
  z-index: 999;
  width: fit-content;
  max-width: 275px;
  padding: 16px;
  background: #222222;
  border-radius: 8px;
  color: #fff;
  transition: opacity 0.3s, top 0.3s;
  font-size: 12px;
  text-align: center;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
